import { render, staticRenderFns } from "./ratifyAccord.vue?vue&type=template&id=ca248fd2&scoped=true&"
import script from "./ratifyAccord.vue?vue&type=script&lang=js&"
export * from "./ratifyAccord.vue?vue&type=script&lang=js&"
import style0 from "./ratifyAccord.vue?vue&type=style&index=0&id=ca248fd2&prod&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "ca248fd2",
  null
  
)

export default component.exports